import React, { useEffect } from "react";
import { Button, Col, Input, Row } from "antd";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types"; // Corrigindo erros de Eslint

const ConfigAuth = (props) => {

  const styles = `
  .Config_Auth_container {
  height: 100%;
  }
  .Config_Auth_rowContainer {
  width: 100%;
  height: 100%;
  }
  .Config_Auth_rowContainer .ant-col {
  height: 100%;
  overflow-y: auto;
  }
  .Config_Auth_AuthForm {
  align-items: center;
  justify-content: center;
  }
  .Config_Auth_authTitle {
  display: flex;
  align-items: center;
  }
  .Config_Auth_itemField {
  padding: 10px 0px;
  }
  .Config_Auth_itemFieldLabel {
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #2f3367;
  }
  .Config_Auth_itemField input {
  border: 1px solid;
  border-radius: 4px;
  color: black;
  }
  .Config_Auth_itemField .ant-input-password {
  border: 1px solid;
  background-color: transparent !important;
  border-radius: 4px;
  }
  .Config_Auth_itemField .Config_Auth_itemFieldLabelCheckbox {
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #afb6c2;
  }
  .Config_Auth_itemField .Config_Auth_itemFieldLabelCheckbox a {
  color: #afb6c2;
  text-decoration: underline;
  }
  .Config_Auth_itemField .Config_Auth_itemFieldError {
  color: #e46772;
  font-size: 14px;
  padding: 2px 0;
  }
  .Config_Auth_itemField input:-webkit-autofill,
  .Config_Auth_itemField input:-webkit-autofill:hover,
  .Config_Auth_itemField input:-webkit-autofill:focus,
  .Config_Auth_itemField textarea:-webkit-autofill,
  .Config_Auth_itemField textarea:-webkit-autofill:hover,
  .Config_Auth_itemField textarea:-webkit-autofill:focus,
  .Config_Auth_itemField select:-webkit-autofill,
  .Config_Auth_itemField select:-webkit-autofill:hover,
  .Config_Auth_itemField select:-webkit-autofill:focus {
  -webkit-box-shadow: 0 0 0px 1000px transparent inset;
  transition: background-color 5000s ease-in-out 0s;
  }
  .Config_Auth_authSubmit {
  margin-top: 20px;
  background: #007dfa !important;
  border-radius: 4px !important;
  width: 100%;
  border: none !important;
  box-shadow: none !important;
  color: #fff !important;
  font-weight: 600 !important;
  font-size: 18px;
  }
  .Config_Auth_authSubmit:hover {
  transform: scale(1.05);
  background-color: rgba(0, 125, 250, 0.761);
  }
  .Config_Auth_AuthImage {
  color: #fff;
  width: 100%;
  height: 100%;
  }
  .Config_Auth_authBlock {
  left: 20%;
  width: 60%;
  top: 25%;
  position: relative;
  }
  .Config_Auth_AuthImage {
  position: relative;
  }
  @media only screen and (max-width: 1024px) {
  .Config_Auth_AuthForm {
    padding: 0;
  }
  .Config_Auth_AuthImage {
    display: none !important;
  }
  }
  @media only screen and (max-width: 768px) {
  .Config_Auth_AuthImage {
    display: none !important;
  }
  }
    `;

    useEffect(() => {
      const styleSheet = document.createElement("style");
      styleSheet.type = "text/css";
      styleSheet.innerText = styles;
      document.head.appendChild(styleSheet);
  
      return () => {
        document.head.removeChild(styleSheet);
      };
    }, [styles]);

  let navigate = useNavigate();

  const {
    authFields,
    authSubmit,
    authImage,
    onsubmit,
    success,
    errorMessage,
    textImage,
  } = props;

  return (
    <div className="Config_Auth_container">
      <Row className="Admin_Auth_rowContainer">
        <Col xs={24} md={10} lg={10} xl={10} className="Config_Auth_AuthForm">
          {textImage && <div className="Admin_LogoTextImage">{textImage}</div>}
          <div className="Config_Auth_authBlock">
            {!success && (
              <form className="Config_Auth_AuthForm" onSubmit={onsubmit}>
                {authFields.map((itemField, indexField) => {
                  switch (itemField.type) {
                    case "text":
                      return (
                        <div className="Config_Auth_itemField" key={indexField}>
                          <label
                            htmlFor="username"
                            className="Config_Auth_itemFieldLabel"
                          >
                            {itemField.label}
                          </label>
                          <Input
                            placeholder={itemField.placeholder ?? ""}
                            value={itemField.value}
                            id="username"
                            type="text"
                            name="username"
                            autoComplete="username"
                            onChange={(event) => {
                              if (typeof itemField.setField === "function") {
                                itemField.setField(event.target.value);
                              }
                            }}
                            onKeyPress={(event) => {
                              if (event.key === "Enter") {
                                onsubmit();
                              }
                            }}
                          />
                          {itemField.error && (
                            <div className="Config_Auth_itemFieldError">
                              {itemField.error}
                            </div>
                          )}
                        </div>
                      );
                    case "password":
                      return (
                        <div className="Config_Auth_itemField" key={indexField}>
                          <label
                            htmlFor="password"
                            className="Config_Auth_itemFieldLabel"
                          >
                            {itemField.label}
                          </label>
                          <Input.Password
                            placeholder={itemField.placeholder ?? ""}
                            id="password"
                            value={itemField.value}
                            type="password"
                            name="password"
                            autoComplete="current-password"
                            iconRender={(visible) =>
                              visible ? (
                                <FontAwesomeIcon
                                  icon={faEyeSlash}
                                ></FontAwesomeIcon>
                              ) : (
                                <FontAwesomeIcon icon={faEye}></FontAwesomeIcon>
                              )
                            }
                            onChange={(event) => {
                              if (typeof itemField.setField === "function") {
                                itemField.setField(event.target.value);
                              }
                            }}
                            onKeyPress={(event) => {
                              if (event.key === "Enter") {
                                onsubmit();
                              }
                            }}
                          />
                          {itemField.error && (
                            <div className="Config_Auth_itemFieldError">
                              {itemField.error}
                            </div>
                          )}
                        </div>
                      );
                    default:
                      return null;
                  }
                })}
              </form>
            )}
            {!success && (
              <Button
                className="Config_Auth_authSubmit"
                onClick={() => {
                  if (typeof onsubmit === "function") {
                    onsubmit();
                  }
                }}
              >
                {authSubmit}
              </Button>
            )}
            {errorMessage && (
              <div className="Config_Auth_errorMessage">
                <div dangerouslySetInnerHTML={{ __html: errorMessage }}></div>
              </div>
            )}
            {success && (
              <Button
                className="Config_Auth_authSubmit"
                onClick={() => navigate("/admin-sign-in")}
              >
                Acessar Painel ADM Pagmaq
              </Button>
            )}
          </div>
        </Col>

        <Col xs={24} md={14} lg={14} xl={14} className="Config_Auth_AuthImage">
          {authImage && (
            <img className="Config_Auth_AuthImage" src={authImage} alt="auth" />
          )}
        </Col>
      </Row>
    </div>
  );
};

ConfigAuth.propTypes = {
  authFields: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      placeholder: PropTypes.string,
      value: PropTypes.string,
      setField: PropTypes.func,
      error: PropTypes.string,
      type: PropTypes.string,
    })
  ).isRequired,
  authSubmit: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  authImage: PropTypes.string,
  onsubmit: PropTypes.func.isRequired,
  success: PropTypes.bool,
  errorMessage: PropTypes.string,
  textImage: PropTypes.string,
};

export default ConfigAuth;
